package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.RoomRawQuery
import androidx.room3.coroutines.createFlow
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.FavoriteVodStreamEntity
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class VodsFavDao_Impl(
  __db: RoomDatabase,
) : VodsFavDao() {
  private val __db: RoomDatabase

  private val __insertAdapterOfFavoriteVodStreamEntity: EntityInsertAdapter<FavoriteVodStreamEntity>

  private val __deleteAdapterOfFavoriteVodStreamEntity:
      EntityDeleteOrUpdateAdapter<FavoriteVodStreamEntity>

  private val __pagingSourceDaoReturnTypeConverter: PagingSourceDaoReturnTypeConverter =
      PagingSourceDaoReturnTypeConverter()
  init {
    this.__db = __db
    this.__insertAdapterOfFavoriteVodStreamEntity = object : EntityInsertAdapter<FavoriteVodStreamEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `vodFavoritesTable` (`streamId`,`sortOrder`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: FavoriteVodStreamEntity) {
        statement.bindLong(1, entity.streamId.toLong())
        statement.bindLong(2, entity.sortOrder)
      }
    }
    this.__deleteAdapterOfFavoriteVodStreamEntity = object : EntityDeleteOrUpdateAdapter<FavoriteVodStreamEntity>() {
      protected override fun createQuery(): String = "DELETE FROM `vodFavoritesTable` WHERE `streamId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: FavoriteVodStreamEntity) {
        statement.bindLong(1, entity.streamId.toLong())
      }
    }
  }

  public override suspend fun insert(item: FavoriteVodStreamEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfFavoriteVodStreamEntity.insert(_connection, item)
  }

  public override suspend fun insert(items: List<FavoriteVodStreamEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfFavoriteVodStreamEntity.insert(_connection, items)
  }

  public override suspend fun delete(item: FavoriteVodStreamEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfFavoriteVodStreamEntity.handle(_connection, item)
  }

  public override suspend fun delete(items: List<FavoriteVodStreamEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfFavoriteVodStreamEntity.handleMultiple(_connection, items)
  }

  public override fun allAsFlow(): Flow<List<FavoriteVodStreamEntity>> {
    val _sql: String = "SELECT * FROM vodFavoritesTable"
    return createFlow(__db, false, arrayOf("vodFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfSortOrder: Int = getColumnIndexOrThrow(_stmt, "sortOrder")
        val _result: MutableList<FavoriteVodStreamEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: FavoriteVodStreamEntity
          _item = FavoriteVodStreamEntity()
          _item.streamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          _item.sortOrder = _stmt.getLong(_columnIndexOfSortOrder)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSource(): PagingSource<Int, FavoriteVodStreamEntity> {
    val _sql: String = "SELECT * FROM vodFavoritesTable "
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodFavoritesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<FavoriteVodStreamEntity>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
          val _columnIndexOfSortOrder: Int = getColumnIndexOrThrow(_stmt, "sortOrder")
          val _result: MutableList<FavoriteVodStreamEntity> = mutableListOf()
          while (_stmt.step()) {
            val _item: FavoriteVodStreamEntity
            _item = FavoriteVodStreamEntity()
            _item.streamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
            _item.sortOrder = _stmt.getLong(_columnIndexOfSortOrder)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun hasEntity(id: Int): Boolean {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodFavoritesTable WHERE streamId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, id.toLong())
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun hasEntityAsFlow(id: Int?): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodFavoritesTable WHERE streamId = ?)"
    return createFlow(__db, false, arrayOf("vodFavoritesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM vodFavoritesTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM vodFavoritesTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
